import { render, staticRenderFns } from "./IconInfrastructuur.vue?vue&type=template&id=74d52457&scoped=true"
import script from "./IconInfrastructuur.vue?vue&type=script&lang=ts"
export * from "./IconInfrastructuur.vue?vue&type=script&lang=ts"
import style0 from "./IconInfrastructuur.vue?vue&type=style&index=0&id=74d52457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d52457",
  null
  
)

export default component.exports